export const EMAIL_PATTERN =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))\s*$/;

export enum PasswordRequirementsMessage {
  MustContainUppercaseLetter = 'Password must contain an upper case letter',
  MustContainSymbol = 'Password must contain a special symbol',
  MinLength = 'Password must contain at least 8 characters',
  MustContainNumber = 'Password must contain a number',
  Required = 'Password is required',
}

export enum ConfirmPasswordRequirementsMessage {
  PasswordsMustMatch = 'Passwords must match',
  Required = 'Repeat password is required',
}

export enum EmailRequirementsMessage {
  Required = 'Email is required',
  ValidEmail = 'Please, enter valid email',
}

export enum RequirementsMessage {
  FirstName = 'First name is required',
  LastName = 'Last name is required',
  CompanyName = 'Company name is required',
  Industry = 'Industry is required',
  CompanyDescription = 'Company description is required',
  FormulaName = 'Formula name is required',
}
